module.exports = __webpack_public_path__ + "static/media/horizontalHardshell.d613eea5.svg";